'use strict';

/**
 * Simple shim for window.requestAnimationFrame because some older browsers (and PhantomJS) don't support it. This isn't
 * an exact replacement for requestAnimationFrame but should work for our purposes.
 * @param  {Function} callback
 */
function animationFrame(callback) {
    if (window && window.requestAnimationFrame) {
        window.requestAnimationFrame(callback);
    } else {
        setTimeout(callback, 50);
    }
}

module.exports = animationFrame;



// WEBPACK FOOTER //
// ./assets/js/global/utils/requestAnimationFrame.es.js